export default function ResRentalProgramDetails() {
  return (
    <div>
      <div className="mbhistoric-bg bg-image">
        <div className="gap-spacer"></div>
        <div className="page-title top-cap-outlines">
          <h2>Residential Rental License Permit Program</h2>
        </div>

        {/*End Large Image Space*/}
        {/*Start Main Content*/}
        <div className="content-fluid">
          <div className="mb-960-center-column mid-side-outlines">
            {/*Full Width Element*/}
            <p>
              In accordance with{" "}
              <a href="https://ecode360.com/32704512">
                Ordinance No. 1019&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i>
              </a>
              , all residential rental properties in Morrisville Borough are required to be <strong>registered and inspected annually</strong>.
            </p>
            <p>
              The Residential Rental License Permit is designed to ensure all rental properties meet <strong>minimum health and safety standards</strong>, while proactively identifying and addressing any substandard
              housing conditions. Regular inspections help protect residents and improve the overall quality of rental housing in our community.
              
            </p>
            <hr/>
<h4>What Property Owners Need to Know</h4>
<ul>
    <li><strong>Annual Registration Deadline:</strong>
        <ul className="no-bullets">
            <li>All rental properties must be registered by <strong>January 31st</strong> each year.</li>
            <li>Late submissions may result in <strong>penalties, violations, and late fees</strong>.</li>
        </ul>
    </li>
    <li><strong>Inspection Requirements:</strong>
        <ul>
            <li>Properties must pass an annual inspection.</li>
            <li>If a property fails inspection, <strong>a reinspection fee</strong> may apply.</li>
            <li>A <strong>new application, fee, and inspection</strong> are required each time there is a change in tenancy — <strong>before the new tenant moves in</strong>.</li>
        </ul>
    </li>
    </ul>

    <p>
    We believe that safe, well-maintained housing is a shared goal among property owners, tenants, and the Borough. By working together, we can ensure that our community remains a safe and welcoming place to live.
    </p>
    <p>
Thank you for your continued cooperation!
</p>
<hr/>

<h4>How to Complete the Rental License Permit Process</h4>
<strong>Required Document: <a href="./docs/code/Residential-Rental-License-Permit-Registration.pdf" target="_blank" rel="noopener noreferrer">&nbsp;
              <i className="fa-solid fa-file-pdf fa-lg"></i>
              &nbsp;Residential Rental License Permit Registration </a> </strong>
              <p>Follow the steps below to register your rental property and obtain a valid Rental License Permit:</p>

<ul>
    <li><strong>Step 1: Submit the Application</strong>
        <ul className="no-bullets">
            <li>Complete the <a href="./docs/code/Residential-Rental-License-Permit-Registration.pdf" target="_blank" rel="noopener noreferrer">&nbsp;
              <i className="fa-solid fa-file-pdf fa-lg"></i>
              &nbsp;Residential Rental License Permit Registration </a> and submit it along with the required payment. The fee is <strong className="fst-italic">$100 per unit</strong> and is payable by cash, check or money order. Only fully completed applications with payment will be accepted for review.</li>
        </ul>
    <br/></li>
    <li><strong>Step 2: Application Processing</strong>
        <ul className="no-bullets">
            <li>The property owner is responsible for scheduling inspection through the Code Enforcement Office.</li>
            <li>Email: <a href="mailto:rentals@morrisvilleboro.org">rentals@morrisvilleboro.org</a></li>
            <li>Phone: <a href="tel:2152958181p134">215-295-8181 ext. 134</a></li>
        </ul>
    <br/></li>
    <li><strong>Step 3: Property Inspection</strong>
        <ul className="no-bullets">
            <li>A timely inspection will be conducted by the Code Enforcement Office. If any code violations are identified, you will receive an inspection report detailing the required corrections before the property can be approved for rental.</li>
        </ul>
    <br/></li>
    <li><strong>Step 4: Complete Repairs &amp; Schedule Reinspection</strong>
        <ul className="no-bullets">
            <li>After all listed violations have been corrected, contact the Code Enforcement Office to arrange a <strong>reinspection</strong>.  The <strong className="fst-italic">re-inspection fee of $80 per unit</strong> must be paid before the Rental License Permit can be issued.  </li>
        </ul>
    <br/></li>
    <li><strong>Step 5: Permit Issuance</strong>
        <ul className="no-bullets">
            <li>Once your property passes inspection, a <strong>Rental License Permit</strong> will be issued. At this point, your property is officially approved for rental.</li>
        </ul>
    </li>
</ul>
       <hr/>  
<p>
<h4>Rental Property Inspections</h4>
<p>As part of the Rental License Permit process, all rental properties in Morrisville Borough must undergo an inspection by the <strong>Code Enforcement Office</strong> to ensure compliance with <strong>minimum property maintenance standards.</strong></p>
<p>Inspections are conducted based on the <a href="https://codes.iccsafe.org/content/IPMC2018P2">
                2018 International Property Maintenance Code&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i>
              </a>, along with applicable <strong>local amendments</strong>.</p>
<p><strong>What to Expect:</strong></p>

<ul>
    <li><strong>Scheduling:</strong>
        <ul className="no-bullets">
            <li>The property owner is responsible for scheduling inspection through the Code Enforcement Office. Property owners will have the opportunity to coordinate with their tenants to schedule a mutually convenient inspection time.  </li>
            <li>Email: <a href="mailto:rentals@morrisvilleboro.org">rentals@morrisvilleboro.org</a></li>
            <li>Phone: <a href="tel:2152958181p134">215-295-8181 ext. 134</a></li>
        </ul>
    <br/></li>
    <li><strong>Inspection Process:</strong>
        <ul className="no-bullets">
            <li>A <strong>Code Enforcement Officer</strong> will inspect the property and document any violations or issues using a standard inspection form. These issues must be addressed before the rental unit can be legally operated.</li>
        </ul>
    <br/></li>
    <li><strong>Corrections &amp; Reinspection:</strong>
        <ul className="no-bullets">
            <li>Once all noted corrections are made, the property owner must contact the Code Enforcement Office to schedule a <strong>reinspection</strong>.</li>
            <li><div className="fst-italic"><i className="fa-solid fa-circle-arrow-right"></i>&nbsp;Please note: A reinspection fee of $80 per unit is required before the Rental License Permit can be issued.</div></li>
        </ul>
    <br/></li>
</ul>
 <p>
         We encourage property owners to review the &nbsp;<a href="../docs/code/Rental-Housing-Checklist-022025.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp;Rental Housing Checklist
          </a> prior to inspection to ensure the property is ready.
         </p>
         </p> 
        







        </div>
        <div className="page-footer bottom-cap-outlines">&nbsp;</div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
      </div></div></div>
    
  );
}
